export default __webpack_public_path__ + "static/media/player-play-circle.e5cd91ea.svg";